export default "__VITE_ASSET__Dmuqxlvx__"